import useApiManager from 'networking/ApiManager';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setAlerts } from 'redux/Slices';
import { add, arrowDown, arrowUp, editIconY, editTheme, uploaded } from 'res/images';
import { CommonAlert, EmptyView } from 'whealth-core-web/components';
import { dateFormat, profileImage, splitArrData, teamRoles, timeFormat } from 'whealth-core-web/components/Helper';
import CommonToolTip from './components/CommonToolTip';
import { STRING } from 'constants/String';
import { Modal, Button, DatePicker } from 'rsuite';
import { useFilter } from './components/FilterContext';
import { CoreDropDown, Select2DropDown, CoreInputBox } from 'whealth-core-web/components';
import AppointmentDescription from './components/AppointmentVer2/AppointmentDescription';
import { text } from '@fortawesome/fontawesome-svg-core';
import { toast, ToastContainer } from 'react-toastify';
import SelectDropDown from './components/common/SelectDropDown';
function RenderService(props) {
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showAppointment, setAppointment] = useState(false)
  const [ser_Appointment, set_SerAppointment] = useState([])
  const [documentList, setDocumentList] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const { newQuestions, userData, getPatientData, isNivanCare, data } = props;
  const [activeTab, setActiveTab] = useState('prc');
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [recordModal, setRecordModal] = useState(false);
  const [showPreview, setPreview] = useState(false)
  const [serviceData, setServiceData] = useState([]);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('alert-danger');
  const [totalPages, setTotalPages] = useState(1);
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { setActiveDate } = useFilter();
  const [recordErrors, setRecordErrors] = useState({});
  const [createdAppointment, setCreatedAppointment] = useState({});
  const [labels, setLabels] = useState(false)
  const [expandedItems, setExpandedItems] = useState({});
  const [toggle, setToggle] = useState({});
  const [sessionTime, setSessionTime] = useState(30)
  const [selectedFrequency, setSelectedFrequency] = useState('');
  const [increaseNumber, setIncreaseNumber] = useState(0);
  const [preferredFrom, setPreferredFrom] = useState(null);
  const [sessionData, setSessionData] = useState([])
  const [sessionStartDate, setSessionStartDate] = useState(new Date());
  const [notes, setNotes] = useState([])
  const [sessionNotes, setSessionNotes] = useState({});
  let weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let price;
  let activedate = localStorage.getItem('activeDate');
  let activeDate = new Date(activedate)
  const dateFormat = (date) => {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
  };

  const formatTime = (date) => {
    if (!date) return '';
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);
  };


  useEffect(() => {
    if (!recordModal) {
      setRecordErrors({});
      setCreatedAppointment({
        payment_type: null,
        payment_mode: null,
        payment_from: null,
        amount: null,
        patient_attendance_status: null,
        payment_with_id: null,
        payment_with_source: null,
      });
    }
  }, [recordModal]);
  const resetAppointmentForm = () => {
    setSelectedFrequency('');
    setSelectedDates([]);
    setPreferredFrom(null);
    setSessionTime(30);
    setIncreaseNumber(0);
    setActiveDate(new Date());
  };

  useEffect(() => {
    getListData();
  }, []);


  useEffect(() => {
    serviceData.forEach(() => {
      return () => {
        Document = []
        setPreferredFrom = []
        setSelectedDates = []
        setNotes = []
      }
    })
  }, [showDocumentModal, showAppointment, recordModal])
  useEffect(() => {
    if (selectedFrequency == 5) {
      setLabels(false)
    }
    else {
      setLabels(true)
      setSelectedDates([])
    }
  }, [selectedFrequency])
  const getListData = () => {
    setIsLoading(true);
    ApiClient.patientServiceList(id)
      .then((res) => {
        setServiceData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const renderMultiSelect = (data) => {
    let ansArr = splitArrData(data.answer, '|');
    return (
      <ul>
        {ansArr.map((item, index) => {
          return <li key={index}>{item}</li>;
        })}
      </ul>
    );
  };
  const renderConsultantDate = () => {
    return (
      <div className='hideCalender'>
        <DatePicker
          onSelect={(date) => {
            setIncreaseNumber(0);
            setActiveDate(new Date(date));
            // localStorage.setItem('activeDate', new Date(date));
          }}
          value={activeDate}
          oneTap
          style={{ width: 80 }}
        />
      </div>
    );
  };
  function dateTimeFormat(dateString) {
    if (!dateString) return '';

    const date = new Date(dateString.replace(' ', 'T'));
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    });

    const formattedTime = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${formattedDate} at ${formattedTime}`; // e.g., June 05, 2025 at 06:30 PM
  }

  const serviceDelete = (questionId) => {
    setIsLoading(true);
    ApiClient.deleteService(id, questionId)
      .then((res) => {
        getListData();
        dispatch(setAlerts({ patient: { title: 'Patient Service deleted successfully.', type: 'alert-success' } }));
        setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        if (err.response.status == 500) {
          setIsShowAlert('Internal server error');
        } else {
          setIsShowAlert(err.response.data.message);
        }
        setAlertType('alert-danger');
        setIsShowAlert(err.response.data.detail || err.response.data.message);
        console.log(err);
      });
  };
  const renderTabs = () => (
  <div class="default-tab">
                    <ul class="nav nav-tabs mb-3" role="tablist">
                    <li class="nav-item"><a class={activeTab == 'prc' ? 'nav-link active': 'nav-link'} 
                        style={activeTab == 'prc' ? { cursor: "pointer",color: "#133696"} : {cursor: "pointer" ,color: "#575757"}}
                        data-toggle="tab"  onClick={(e) => {
                            e.preventDefault();
                            setActiveTab('prc');
                          }}>PRC</a>
                        </li>
                        <li class="nav-item"><a class={activeTab == 'crp' ? 'nav-link active': 'nav-link'} 
                        style={activeTab == 'crp' ? { cursor: "pointer",color: "#133696"} : {cursor: "pointer" ,color: "#575757"}}
                        data-toggle="tab"  onClick={(e) => {
                            e.preventDefault();
                            setActiveTab('crp');
                          }}>CRP</a>
                        </li>
                       
                        </ul>
                        </div>
);
  const serviceCrpDetailsObj = (data) => {
    return data?.map((item, i) => {
      return (
        <div className='d-flex'>
          <div className='w-100'>
            <span className='semiBold capitalize'>Type Of CRP: {item?.crp_type} · </span>
            <br />
            <span className='semiBold capitalize'> Session Booked · </span>
            <span className='prescriptiontime'>
              <pre className='zeefitness prefont_family firstletter_capitalize'>{item?.session_booked}</pre>
            </span>
            <span className='semiBold capitalize'>Session Delivered · </span>
            <span className='prescriptiontime'>
              <pre className='zeefitness prefont_family firstletter_capitalize'>{item.session_delivered}</pre>
            </span>
            <span className='semiBold capitalize'>Price · </span>
            <span className='prescriptiontime'>setAppointment
              <pre className='zeefitness prefont_family firstletter_capitalize'>₹{item.price}</pre>
            </span>
            <span className='semiBold capitalize'>Hospital · </span>
            <span className='prescriptiontime'>
              <pre className='zeefitness prefont_family firstletter_capitalize'>{item.location?.name}</pre>
            </span>
            <span className='semiBold capitalize'>Doctor · </span>
            <span className='prescriptiontime'>
              <pre className='zeefitness prefont_family firstletter_capitalize'>{item.doctor?.full_name}</pre>
            </span>
            <span className='semiBold capitalize'>Care Manager · </span>
            <span className='prescriptiontime'>
              <pre className='zeefitness prefont_family firstletter_capitalize'>{item.care_manager?.full_name}</pre>
            </span>
            <hr />
          </div>
        </div>
      );
    });
  };

  const serviceDataObj = (data) => {
    if (data?.length) {
      let sortedData = [...data].sort(function (a, b) {
        return a.order - b.order;
      });
      return sortedData.map((item, i) => {
        return (
          <div className='d-flex'>
            <div className='w-100'>
              <span className='semiBold capitalize'>{item.label} · </span>
              <span className='prescriptiontime'>
                <pre className='zeefitness prefont_family firstletter_capitalize'>
                  {item.type == 'multi_select'
                    ? renderMultiSelect(item)
                    : item.type == 'date' && dateFormat(item.answer) != 'Invalid Date'
                      ? dateFormat(item.answer)
                      : item.type !== 'date_time' && item.answer}
                  {item.type == 'date_time' && dateFormat(item.answer)} {item.type == 'date_time' && timeFormat(item.answer)}
                </pre>
              </span>
            </div>
          </div>
        );
      });
    }
  };

  const tagCont = {
    display: 'flex',
    padding: '4px 6px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    borderRadius: '10px',
    border: '0.5px solid #656364',
    background: '#FFF',
  };
  const renderNewServiceList = () => {
    const getStatusColor = (status) => {
      switch (status) {
        case 'scheduled':
          return '#136C0B';
        case 'scheduled-due':
          return '#DD461A';
        case 'dropped':
          return '#FF0000';
        default:
          return '#656364';
      }
    };

    const getStatusColorDiv = (status) => {
      switch (status) {
        case 'scheduled':
          return '#D2F2D8';
        case 'scheduled-due':
          return '#FFF';
        case 'dropped':
          return '#FBE3DC';
        default:
          return '#D9D9D9';
      }
    };
    // const prcItems = allItems.filter((item) => item?.service?.title !== 'crp');
    // const crpItems = allItems.filter((item) => item?.service?.title === 'crp');
    return serviceData.map((item, index) => {
      price = item.final_bill_amount
const buttonsData = () => {
        return (
          <div className='headingMilestone d-flex justify-content-between'>
            <div className='d-flex'>
              <div className='buttonsDataStyle'>
                <div className='tagContainer capitalize'>
                  <p className='tagsText d-flex gap-1 align-items-center'>
                    {item?.service?.title==='crp'?item?.crp_category:item?.service?.title} |{''}
                    {item.service?.title?.toLowerCase() === 'procedure' ? (
                      item.service_category?.map((category) => <span className='my-blue-shade ml-1 py-1 px-1 rounded-3 fw-semibold'>{category?.title}</span>)
                    ) : (
                      <span className='my-blue-shade ml-1 py-1 px-1 rounded-3 fw-semibold'>{item.service_category?.title}</span>
                    )}
                  </p>
                </div>
              </div>
              <div className='d-flex capitalize'>
                <div
                  style={{
                    backgroundColor: getStatusColorDiv(item.status),
                    border: item?.status === 'scheduled-due' && '1px solid red',
                  }}
                  className='statusTextDiv'
                >
                  <span
                    style={{
                      color: getStatusColor(item.status),
                    }}
                    className='statusText'
                  >
                    {item.status}
                  </span>
                </div>
              </div>
              {/* <div className='d-block  ms-2 '>
                <div className='tagContainer'>
                  <p className='tagsText'>Partially Paid </p>
                </div>
              </div> */}
            </div>
            <div className='memberShipDetails' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              {(!userData?.read_only && (!['doctor', 'ee', 'ee_manager'].includes(userData?.role) || userData?.department?.id == 2)) && (
                <>
                  <div
                    onClick={() => {
                      navigate(`/patient/${id}/serviceDetails/${item.id}/edit`, { state: { id: item.id, item: item } });
                    }}
                    className='mb-2 ms-2 pointer action-images d-flex'
                  >
                    <CommonToolTip placement={'top'} item={<img src={editTheme} className='icon serviceEditIcon' />} showValue={'Edit'} />
                  </div>
                </>
              )}
              {(!['doctor', 'ee', 'ee_manager'].includes(userData.role) || userData?.department?.id == 2) && (
                <div
                  onClick={() => {
                    navigate(`/patient/${id}/serviceDetails/${item.id}/view`, { state: { id: item.id, item: item } });
                  }}
                  className='ms-2 pointer'
                >
                  <CommonToolTip placement={'top'} item={<span class='material-icons-outlined'>visibility</span>} showValue={'View'} />
                </div>
              )}
            </div>
          </div>
        );
      };
      if(activeTab !== 'crp'){
            if (item?.service?.title !== 'crp') {
                  return (
          <div className='cardDataBorder cardDataMargin'>
            <div key={index} className='d-flex'>
              <div className='w-100'>
                <div className='cardMilestone paymentContainer'>
                  {buttonsData()}
                  <div className='d-flex justify-content-between' style={{ alignItems: 'center' }}>
                    <div className='d-block  ms-2 '>
                      {(userData?.role != 'doctor' || userData?.department?.id == 2) && (
                        <p className='feeText'>
                          Total Fee: <span className='prescriptiontime'>₹{item.final_bill_amount > 0 ? item.final_bill_amount : item.estimated_cost} </span>
                        </p>
                      )}
                    </div>
                    <div className='d-flex'>
                      {(!userData?.read_only && (!['doctor', 'ee', 'ee_manager'].includes(userData?.role) || userData?.department?.id == 2)) && (
                        <button
                          onClick={() => {
                            navigate(`/patient/${id}/serviceDetails/${item.id}/edit`, { state: { id: item.id, item: item, page: 2 } });
                          }}
                          type='button'
                          className='btn btn-outline-primary recordPayment'
                        >
                          Record Payment
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-between serviceDetailsHeaderConteiner'>
              <div className='d-block  ms-2 '>
                <p className='createdByText d-flex align-items'>
                  <p className='CreatedByTextHeader'>Created by {item.admin.full_name} </p> on {dateFormat(item.created_at)}, {timeFormat(item.created_at)}
                </p>
              </div>
              <div className='d-flex showDetailsContainer'>
                <p className='createdByText d-flex align-items viewDetailsTxt'>{STRING.SHOW_DETAILS(item?.showDetails)}</p>
                <div onClick={() => toggleDetails(item.id)} className='ms-1 pointer action-images d-flex'>
                  <CommonToolTip
                    placement={'top'}
                    item={<img src={item?.showDetails ? arrowUp : arrowDown} className='icon' />}
                    showValue={STRING.SHOW_DETAILS(item?.showDetails)}
                  />
                </div>
              </div>
            </div>
            {item?.showDetails && renderPaymentDetails(item)}
          </div>
        );
      }
    
      }
      // if (item?.service?.title !== 'crp') {
      // }
      else if(item?.service?.title === 'crp') {
        return (
          <div className='cardDataBorder cardDataMargin'>
            <span>
              <div key={index} className='cardMilestone paymentContainer'>
                {buttonsData()}
                <div className="d-flex justify-content-center align-items-center mb-3" style={{ width: 'auto', marginTop: '-10px' }}>
                  <div
                    className="d-flex px-4 py-2 rounded"
                    style={{
                      backgroundColor: 'white',
                      boxShadow: '0 0 8px rgba(0, 0, 0, 0.05)',
                      borderRadius: '15px',
                      minWidth: '100px',
                      justifyContent: 'space-around',
                      fontSize: '12px',
                      fontWeight: '500',
                      gap: '8px',
                      marginLeft:'75px',
                      marginTop: '-30px'
                    }}
                  >
                    <div className="text-center">
                      <div style={{ color: '#000' }}>Booked</div>
                      <div style={{ fontWeight: 'bold' }}>{item?.crp_details?.reduce((acc, item) => acc + (item?.session_booked || 0), 0) || 0}</div>
                    </div>
                    <div className="vr" />
                    <div className="text-center">
                      <div style={{ color: '#000' }}>Scheduled</div>
                      <div style={{ fontWeight: 'bold' }}>{item?.crp_details?.reduce((acc, item) => acc + (item?.session_scheduled || 0), 0) || 0}</div>
                    </div>
                    <div className="vr" />
                    <div className="text-center">
                      <div style={{ color: '#000' }}>Delivered</div>
                      <div style={{ fontWeight: 'bold' }}>{item?.crp_details?.reduce((acc, item) => acc + (item?.session_delivered || 0), 0) || 0}</div>
                    </div>
                    <div className="vr" />
                    <div className="text-center">
                      <div style={{ color: '#000' }}>Left</div>
                      <div style={{ fontWeight: 'bold' }}>{item?.crp_details?.reduce((acc, item) => acc + (item.session_left || 0), 0) || 0}</div>
                    </div>
                  </div>
                </div>
                <div className='d-flex  justify-content-between align-items-center'>
                  <div className='ms-2'>
                    {(userData?.role !== 'doctor' || userData?.department?.id == 2)  && (
                      <>
                        <p className='feeText' style={{ fontSize: '16px', marginBottom: '5px', color: '#6c757d', marginTop: '-22px' }}>
                          {item?.crp_package_name || null}
                        </p>
                        <p className='feeText' style={{ fontSize: '14px', marginBottom: '4px' }}>
                          Total Package Price: <span className='prescriptiontime'><strong>₹{item.final_bill_amount > 0 ? item.final_bill_amount : item.estimated_cost}</strong></span>
                        </p>
                        <p className='feeText' style={{ color: 'green', fontSize: '14px', fontWeight: 'bold' }}>
                          Paid: ₹{item?.total_paid_amount || 0}
                        </p>
                      </>
                    )}
                  </div>
                  <div className='d-flex flex-column align-items-end me-2 gap-2'>
                    {(!userData?.read_only && (!["doctor", "ee", "ee_manager"].includes(userData?.role) || userData?.department?.id == 2))  && (
                      <>
                        <button
                          onClick={()=>navigate(`/patient/${id}/serviceDetails/${item.id}/edit`, { state: { id: item.id, item: item,page:2 } })}
                          style={{ marginTop: '-12px' }}
                          type='button'
                          className='btn btn-outline-primary recordPayment'
                        >
                          Record Payment
                        </button>
                        <button type='button' style={{
                          backgroundColor: 'white',
                          borderRadius: '25px'
                        }}
                          className='btn btn-outline-primary recordPayment'
                          onClick={() => {
                            item.referral_slip !== null ? setDocumentList([{ name: 'Government Insurance', link: item?.referral_slip }]) : setDocumentList([])
                            setShowDocumentModal(true)
                          }}
                        >
                          Show Document
                        </button>
                        {/* <button type='button' style={{ color: 'white', backgroundColor: '#133696', width: '120px' }} className='btn recordPayment'
                          onClick={() => {
                            setAppointment(true)
                            setSessionData({
                              "clinic": item?.crp_details[0]?.location?.name || null,
                              "Doctor": item?.crp_details[0]?.doctor?.full_name || null,
                              "crp_package": 'hello',
                              "Booked": item?.crp_details[0]?.session_booked,
                              "Delivered": item?.crp_details[0]?.session_delivered,
                              "Scheduled": item?.crp_details[0]?.session_scheduled,
                              "left": item?.crp_details[0]?.session_left
                            })
                          }}
                        >
                          Book Session
                        </button> */}
                      </>
                    )}
                  </div>
                </div>
                <div className='d-flex justify-content-between align-items-center mt-3 serviceDetailsHeaderConteiner'>
                  <div className='ms-2'>
                    <p className='createdByText mb-0'>
                      <span className='CreatedByTextHeader'>Created by {item.admin.full_name}</span> on {dateFormat(item.created_at)}, {timeFormat(item.created_at)}
                    </p>
                  </div>
                  <div className='d-flex align-items-center me-2'>
                    <p className='createdByText mb-0 viewDetailsTxt' style={{ fontSize: '12px', fontWeight: '10px' }}>{STRING.VIEW_SPECIALITY_DETAILS(item?.showDetails)}</p>
                    <div onClick={() => {
                      toggleDetails(item.id)
                    }} className='ms-1 pointer action-images'>
                      <CommonToolTip
                        placement='top'
                        item={<img src={item?.showDetails ? arrowUp : arrowDown} className='icon' style={{ width: '20px', height: '20px' }} />}
                        showValue={STRING.SHOW_DETAILS(item?.showDetails)}
                      />
                    </div>
                  </div>
                </div>
                {/* Optional expanded payment details */}
                {item?.showDetails && renderPaymentDetails(item)}
              </div>
            </span>
          </div>

        )
      }
    });
  };
  const renderPaymentDetails = (item) => {
    if (item?.crp_details.length !== 1) {
      // let data = item.crp_details;
      return (
        <>
          <div className='table-responsive tableContainer'>
            <table className='w-100 table removeBottomMargin'>
              <thead className='tableHeader '>
                <tr className='serviceDetailsHeaderConteiner'>
                  <th>Speciality</th>
                  <th>Doctor</th>
                  <th>Location</th>
                  <th>Price / Session</th>
                  <th></th>
                  {(userData?.role !== 'doctor' || userData?.department?.id == 2) && <th></th>}
                </tr>
              </thead>
              <tbody>
                {item?.crp_details.map((item, index) => {
                  return [
                    <tr key={`main-${item.id}`} className='capitalize' style={{ backgroundColor: '#f5f7fe' }}>
                      <td style={{ verticalAlign: 'middle' }} className={item?.payment_type === 'emi' ? 'text-uppercase' : ''}>
                        {item?.crp_type}
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>{item?.doctor?.full_name || "Null"}</td>
                      <td style={{ verticalAlign: 'middle' }}>{item?.location?.name}</td>
                      <td style={{ verticalAlign: 'middle' }}>₹{Number(price) === 0 || null ? (Number(item?.price) / item?.session_booked).toFixed(2) : (Number(price) / item?.session_booked).toFixed(2)}</td>
                      <td >
                        <div
                          style={{
                            marginLeft: 'auto',
                            alignItems: 'center',
                            display: 'flex',
                            background: 'rgba(0, 0, 0, 0.01)',
                            borderRadius: '10px',
                            padding: '8px 12px',
                            gap: '20px',
                            justifyContent: 'space-between',
                            fontSize: '10px',
                            fontWeight: 500,
                            boxShadow: '0px 1px 3px rgba(0,0,0,0.05)',
                            width: 'max-content',
                            minWidth: '320px',
                            margin: 'auto',
                          }}
                        >
                          {[
                            { label: 'Booked', value: item?.session_booked ?? 0 },
                            { label: 'Scheduled', value: item?.session_scheduled ?? 0 },
                            { label: 'Delivered', value: item?.session_delivered ?? 0 },
                            { label: 'Left', value: item?.session_left ?? 0 },
                          ].map((stat, idx) => (
                            <div
                              key={stat.label}
                              style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '0 8px',
                                borderLeft: idx !== 0 ? '1px solid #ddd' : 'none',
                              }}
                            >
                              <div style={{ color: '#333' }}>{stat.label}</div>
                              <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#2f438f' }}>{stat.value}</div>
                            </div>
                          ))}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex align-items-center me-2'>
                          <p className='createdByText mb-0 viewDetailsTxt'>
                            {STRING.VIEW_SESSIONS_DETAILS(item?.showDetails)}
                          </p>
                          <div
                            onClick={() => {
                              setCreatedAppointment(item)
                              toggleDetails2(item.id)
                            }
                            }
                            className='ms-1 pointer action-images'
                          >
                            <CommonToolTip
                              placement='top'
                              item={<img src={expandedItems[item.id] ? arrowUp : arrowDown} className='icon' style={{ width: '20px', height: '20px' }} />}
                              showValue={STRING.VIEW_SESSIONS_DETAILS(expandedItems[item.id])}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>,
                    // Session Detail Row
                    expandedItems[item.id] && (
                      <tr key={`detail-${item.id}`} style={{ backgroundColor: '#f5f7fe' }}>
                        <td colSpan={6}> {/* Adjust colSpan based on number of <th> in thead */}
                          <div
                            className='session-detail-box'
                            style={{
                              backgroundColor: 'white',
                              borderRadius: '10px',
                              padding: '16px',
                              margin: '10px 0',
                              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                            }}
                          >
                            <div className='table-responsive'>
                              <table className='table mb-0'>
                                <thead style={{ backgroundColor: '#f5f7fe' }}>
                                  <tr>
                                    <th style={{ paddingRight: '20px' }}>S.No.</th>
                                    <th style={{ paddingRight: '20px' }}>Status</th>
                                    <th style={{ paddingRight: '20px' }}>Date</th>
                                    <th style={{ paddingLeft: '220px' }}>Notes</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(item?.related_consultations || []).map((session, idx) => (
                                    <tr key={session.id}>
                                      <td>{idx + 1}</td>
                                      <td style={{ marginTop: '10px' }}>
                                        <span
                                          className='badge'
                                          style={{
                                            backgroundColor:
                                              session?.patient_attendance_status !== null
                                                ? '#028b23'
                                                : '#d2f2d8',
                                            color: session?.patient_attendance_status !== null ? '#FFFF' : '#136c0b',
                                            fontWeight: 600,
                                            WebkitTextFillColor: session?.patient_attendance_status !== null ? '#FFFF' : '#136c0b',
                                          }}
                                        >
                                          {session?.patient_attendance_status == null ? 'Scheduled' : session?.patient_attendance_status}
                                        </span>
                                      </td>


                                      {/* <td>{session?.consultant?.full_name || '-'}</td> */}
                                      {/* <td>{session?.slot_time || '-'}</td> */}
                                      <td style={{ marginTop: '10px' }}>{dateTimeFormat(session?.consult_datetime)}</td>
                                      <td style={{ paddingLeft: '116px' }}>
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            marginTop: '8px',
                                          }}
                                        >
                                          <input
                                            type='text'
                                            // value={session?.notes_by_speciality}
                                            value={sessionNotes[session.id] ?? session?.notes_by_speciality ?? ''}
                                            disabled={true}
                                            style={{
                                              border: 'none',
                                              borderBottom: '1px solid #6f42c1',
                                              outline: 'none',
                                              width: '200px', // smaller input width
                                              fontSize: '14px',
                                              paddingBottom: '4px',
                                              backgroundColor: 'transparent',
                                            }}
                                          />

                                          <button
                                            className='btn btn-outline-primary d-flex align-items-center gap-1'
                                            style={{ display: userData?.read_only ? 'none' : undefined }}
                                            onClick={() => {
                                              setNotes([session?.notes_by_speciality, session?.id])
                                              setRecordModal(true);
                                            }}
                                          >
                                            <i className='bi bi-pencil'></i>
                                            <CommonToolTip
                                              placement='top'
                                              item={<img src={editTheme} className='icon serviceEditIcon' />}
                                              showValue='Edit'
                                            />
                                            <span>Notes</span>
                                          </button>
                                        </div>

                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ),
                  ];
                })}
              </tbody>
            </table>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='table-responsive tableContainer'>
            <table className='w-100 table removeBottomMargin'>
              <thead className='tableHeader '>
                <tr className='serviceDetailsHeaderConteiner'>
                  <th>Speciality</th>
                  <th>Doctor</th>
                  <th>Location</th>
                  <th style={{ whiteSpace: 'nowrap' }}>Price / Session</th>
                  <th></th>
                  {(userData?.role !== 'doctor' || userData?.department?.id == 2)  && <th></th>}
                </tr>
              </thead>
              <tbody>
                {item?.crp_details.map((item, index) => {
                  return [
                    <tr key={`main-${item.id}`} className='capitalize' style={{ backgroundColor: '#f5f7fe' }}>
                      <td className={item?.payment_type === 'emi' ? 'text-uppercase' : ''}>
                        {item?.crp_type}
                      </td>
                      <td >{item?.doctor?.full_name}</td>
                      <td >{item?.location?.name}</td>
                      <td >₹{Number(price) === 0 ? (Number(item?.price) / item?.session_booked).toFixed(2): (Number(price) / item?.session_booked).toFixed(2)}</td>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        <div
                          style={{
                            marginLeft: 'auto',
                            alignItems: 'center',
                            display: 'flex',
                            background: 'rgba(0, 0, 0, 0.01)',
                            borderRadius: '10px',
                            padding: '8px 12px',
                            gap: '20px',
                            justifyContent: 'space-between',
                            fontSize: '10px',
                            fontWeight: 500,
                            boxShadow: '0px 1px 3px rgba(0,0,0,0.05)',
                            width: 'max-content',
                            minWidth: '320px',
                            margin: 'auto',
                          }}
                        >
                          {[
                            { label: 'Booked', value: item?.session_booked ?? 0 },
                            { label: 'Scheduled', value: item?.session_scheduled ?? 0 },
                            { label: 'Delivered', value: item?.session_delivered ?? 0 },
                            { label: 'Left', value: item?.session_left ?? 0 },
                          ].map((stat, idx) => (
                            <div
                              key={stat.label}
                              style={{
                                flex: 1,
                                textAlign: 'center',
                                padding: '0 8px',
                                borderLeft: idx !== 0 ? '1px solid #ddd' : 'none',
                              }}
                            >
                              <div style={{ color: '#333' }}>{stat.label}</div>
                              <div style={{ fontWeight: 'bold', fontSize: '14px', color: '#2f438f' }}>{stat.value}</div>
                            </div>
                          ))}
                        </div>
                      </td>
                      <td style={{ paddingLeft: "145px" }}>
                        <div className='d-flex align-items-center me-2'>
                          <p className='createdByText mb-0 viewDetailsTxt' style={{ fontSize: '12px', fontWeight: '10px' }}>
                            {STRING.VIEW_SESSIONS_DETAILS(item?.showDetails)}
                          </p>
                          <div
                            onClick={() => {
                              setCreatedAppointment(item)
                              toggleDetails2(item.id)
                            }
                            }
                            className='ms-1 pointer action-images'
                          >
                            <CommonToolTip
                              placement='top'
                              item={
                                <img
                                  src={expandedItems[item.id] ? arrowUp : arrowDown}
                                  className='icon'
                                  style={{ width: '20px', height: '20px' }}
                                />
                              }
                              showValue={STRING.VIEW_SESSIONS_DETAILS(expandedItems[item.id])}
                            />

                          </div>
                        </div>
                      </td>
                    </tr>,
                    // Session Detail Row
                    expandedItems[item.id] && (
                      <tr key={`detail-${item.id}`} style={{ backgroundColor: '#f5f7fe' }}>
                        <td colSpan={6}> {/* Adjust colSpan based on number of <th> in thead */}
                          <div
                            className='session-detail-box'
                            style={{
                              backgroundColor: 'white',
                              borderRadius: '10px',
                              padding: '16px',
                              margin: '10px 0',
                              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                            }}
                          >
                            <div className='table-responsive'>
                              <table className='table mb-0'>
                                <thead style={{ backgroundColor: '#f5f7fe' }}>
                                  <tr>
                                    <th style={{ paddingRight: '56px' }}>S.No.</th>
                                    <th style={{ paddingRight: '56px' }}>St-atus</th>
                                    <th style={{ paddingRight: '56px' }}>Date</th>
                                    <th style={{ paddingLeft: '220px' }}>Notes</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    item?.related_consultations?.map((datas, i) => {
                                      return (
                                        <tr>
                                          <td style={{ paddingRight: '56px' }}>{i + 1}</td>
                                          <td style={{ marginTop: '10px' }}>
                                            <span
                                              className='badge'
                                              style={{
                                                backgroundColor:
                                                  datas?.patient_attendance_status !== null
                                                    ? '#028b23'
                                                    : '#d2f2d8',
                                                color: datas?.patient_attendance_status !== null ? '#FFFF' : '#136c0b',
                                                fontWeight: 600,
                                                WebkitTextFillColor: datas?.patient_attendance_status !== null ? '#FFFF' : '#136c0b',
                                              }}
                                            >
                                              {datas?.patient_attendance_status == null ? 'Scheduled' : datas?.patient_attendance_status}
                                            </span>
                                          </td>
                                          <td style={{ paddingRight: '56px' }}> {dateTimeFormat(datas?.consult_datetime)}</td>
                                          <td style={{ paddingLeft: '116px' }}>
                                            <div
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px', // space between input and button
                                                marginTop: '8px',
                                              }}
                                            >
                                              <input
                                                type='text'
                                                // value={datas?.notes_by_speciality}
                                                value={sessionNotes[datas.id] ?? datas?.notes_by_speciality ?? ''}
                                                disabled={true}
                                                style={{
                                                  border: 'none',
                                                  borderBottom: '1px solid #6f42c1',
                                                  outline: 'none',
                                                  width: '200px', // smaller input width
                                                  fontSize: '14px',
                                                  paddingBottom: '4px',
                                                  backgroundColor: 'transparent',
                                                }}
                                              />

                                              <button
                                                className='btn btn-outline-primary d-flex align-items-center gap-1'
                                                onClick={() => {
                                                  setNotes([datas?.notes_by_speciality, datas?.id])
                                                  setRecordModal(true);
                                                }}
                                              >
                                                <i className='bi bi-pencil'></i>
                                                <CommonToolTip
                                                  placement='top'
                                                  item={<img src={editTheme} className='icon serviceEditIcon' />}
                                                  showValue='Edit'
                                                />
                                                <span>Notes</span>
                                              </button>
                                            </div>

                                          </td>
                                        </tr>
                                      )
                                    })
                                  }

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ),
                  ];
                })}

              </tbody>
            </table>
          </div>
        </>
      );
    }
  };


  const toggleDetails = (id) => {
    setServiceData((prevData) => prevData.map((item) => (item.id === id ? { ...item, showDetails: !item.showDetails } : item)));
  };
  const toggleDetails2 = (id) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const renderServiceList = () => {
    return serviceData.map((item, index) => {
      const newText = item;
      const buttonsData = () => {
        return (
          <div className='headingMilestone d-flex justify-content-between'>
            <div className='d-flex'>
              <div>
                <b>Assigned On &nbsp; &nbsp;</b>
                {dateFormat(item.created_at)} · {timeFormat(item.created_at)}
              </div>
              <div className='d-block  ms-2 '>
                <span className={`badge bg-info  capitalize ${item.status}`}>{item.status}</span>
              </div>
            </div>

            <div className='memberShipDetails' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <>
                {/* <div
                  className='mb-1 ms-2 pointer'
                  onClick={() => {
                    let windoConfirm = window.confirm('Are you sure you want to delete this service?');
                    if (windoConfirm) {
                      serviceDelete(item.id);
                    }
                  }}
                >
                  <div className='pt-1'>
                    <CommonToolTip
                      placement={'top'}
                      item={<span class='material-icons-outlined'>delete_outline</span>}
                      showValue={'Delete'}
                      />
                      </div>
                      </div> */}

                <div
                  onClick={() => {
                    navigate(`/patient/${id}/serviceDetails/${item.id}/edit`, { state: { id: item.id, item: item } });
                  }}
                  className='mb-2 ms-2 pointer'
                >
                  <CommonToolTip placement={'top'} item={<img src={editIconY} className='icon' style={{ cursor: 'pointer' }} />} showValue={'Edit'} />
                </div>
              </>
            </div>
          </div>
        );

      };
      if (item?.service) {
        return (
          <div className='cardDataBorder'>
            <div key={index} className='d-flex'>
              <div className='w-100'>
                <div className='cardMilestone'>
                  {buttonsData()}
                  <div className='d-flex mt-1 mb-3 justify-content-between align-items-center'>
                    <div className='d-flex'>
                      <div className='me-2'>
                        <img className='rounded coachImage float-start img-fluid' src={profileImage(item.admin.gender, item.admin.profile_url)} />
                      </div>
                      <div className='w-75 '>
                        <h5 className='coachtext capitalize'>{item.admin.full_name}</h5>
                        <p className='zeefitness capitalize'>{teamRoles(item.admin.role)}</p>
                      </div>
                    </div>
                  </div>
                  {item.service ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Service ·
                        <div>
                          <span className='prescriptiontime'>{item.service.title} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}
                  {item.doctor ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Doctor ·
                        <div>
                          <span className='prescriptiontime'>{item.doctor.full_name} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}
                  {item.location ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Hospital ·
                        <div>
                          <span className='prescriptiontime'>{item.location.name} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}
                  {item.care_manager ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Care Manager ·
                        <div>
                          <span className='prescriptiontime'>{item.care_manager.full_name} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}

                  {item?.service_category ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Service Category ·
                        <div>
                          <span className='prescriptiontime'>{item.service_category?.title} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}

                  {item?.crp_details && serviceCrpDetailsObj(item?.crp_details)}
                  {item?.status ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Status ·
                        <div>
                          <span className='prescriptiontime'>{item?.status} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}
                  {item?.data && serviceDataObj(item?.data)}
                  {item.estimated_cost || item.final_bill_amount ? (
                    <div className='w-100 mb-2'>
                      <span className='semiBold capitalize'>
                        Service Cost ·
                        <div>
                          <span className='prescriptiontime'>₹{item.final_bill_amount > 0 ? item.final_bill_amount : item.estimated_cost} </span>
                        </div>
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        );
      }
    });
  };
  const renderDuration = () => {
    let duration =
      new Date().getHours() * 60 +
      new Date().getMinutes() -
      (new Date().getHours() * 60 + new Date().getMinutes());
    let durationHours = parseInt(duration / 60);
    let durationMinutes = duration % 60;
    let value = '';
    if (durationHours > 0) {
      value += durationHours + ' Hours ';
    }
    if (durationMinutes > 0) {
      value += durationMinutes + ' Mins';
    }
    // value = createField?.consult_datetime && createField?.consult_end_datetime ? value : '';
    return <CoreInputBox labelStyle={{ fontSize: 10 }} label='Duration' disabled />;
  };
  const addMinutes = (date, minutes) => {
    const newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
  };
  const frequencyMap = {
    'Every other day': 2,
    'Once every 2 day': 2,
    'Once every 3 day': 3,
    'weekly': 7
  };
  return (

    <div>
      <ToastContainer />
      <AppointmentDescription
        data={notes}
        sessionNotes={sessionNotes}
        setSessionNotes={setSessionNotes}
        // getListData={getListData}
        appointmentDetail={getPatientData}
        cancelModal={recordModal}
        setCancelModal={setRecordModal}
        // handleCancelAppointment={handleCancelAppointment}
        errors={recordErrors}
      />
      <Modal
        open={showDocumentModal}
        onClose={() => setShowDocumentModal(false)}
        size="md"
      >
        <Modal.Header>
          <Modal.Title>Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th><strong>Document Name</strong></th>
                <th><strong>Link</strong></th>
              </tr>
            </thead>
            <tbody>
              {documentList.length > 0 ?
                documentList?.map((doc, index) => {
                  return (
                    <tr key={index}>
                      <td>{doc.name}</td>
                      <td>
                        <a href={doc.link} target="_blank" rel="noopener noreferrer">
                          View Document
                        </a>
                      </td>
                    </tr>
                  )
                })
                :
                <tr>
                  <td colSpan={6} style={{ textAlign: 'center', padding: '12px' }}>
                    No Documents
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setShowDocumentModal(false)} style={{color:'white'}}>
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        open={showAppointment}
        onClose={() => {
          setAppointment(false);
          setSessionData([]);
          resetAppointmentForm();
        }}
      >
        <Modal.Header>
          <Modal.Title className="w-full text-center fw-bold">Add New Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column">
            <CoreInputBox label={'Patient Name'} type="text" disabled value={data.full_name} />
            <CoreInputBox label={'Clinic'} type="text" disabled value={sessionData.clinic} />
            <CoreInputBox label={'Doctor'} type="text" disabled value={sessionData.Doctor} />
            <CoreInputBox label={'CRP Package'} type="text" disabled value={sessionData.crp_package} />
            <CoreInputBox label={'Session Booked'} type="text" disabled value={sessionData.Booked} />
            <CoreInputBox label={'Delivered'} type="text" disabled value={sessionData.Delivered} />
            <CoreInputBox label={'Scheduled'} type="text" disabled value={sessionData.Scheduled} />
            <CoreInputBox label={'Left'} type="text" disabled value={sessionData.left} />

            <label className="inputlabel mt-3">Session Size</label>
            <div className="d-flex align-items-center gap-2">
              <Button className="w-40" onClick={() => setSessionTime((prev) => Math.max(0, prev - 5))}>-</Button>
              <h6 className="mb-0 text-center">{sessionTime} minutes</h6>
              <Button className="w-40" onClick={() => setSessionTime((prev) => prev + 5)}>+</Button>
            </div>

            <br />
            <SelectDropDown
              placement="auto"
              value={selectedFrequency}
              data={[
                { id: '1', title: 'Every other day' },
                { id: '2', title: 'Once every 2 day' },
                { id: '3', title: 'Once every 3 day' },
                { id: '7', title: 'weekly' },
                { id: '5', title: 'Custom' },
              ]}
              labelKey="title"
              label={'Frequency'}
              placeholder={'Frequency'}
              onSelect={(val) => {
                setSelectedFrequency(val.title);
                setSelectedDates([]); // Clear previously selected
              }}
              required
            />

            {selectedFrequency === 'Custom' && (
              <>
                <label className="fw-semibold mb-1 mt-4">
                  <span className="requiredInput text-danger">*</span> Custom Frequency Date Selection
                </label>
                <label className="px-1 py-2 bg-light fw-semibold w-25">Selected Dates: {selectedDates.length}</label>
                <div className="d-flex align-items-center gap-2 py-2 px-3">
                  <div className="px-3 py-2 bg-light rounded text-center fw-semibold">
                    {monthNames[activeDate.getMonth()]}
                    {renderConsultantDate()}
                  </div>
                  <div className="slider-arrow px-2 cursor-pointer" onClick={() => setIncreaseNumber(increaseNumber - 1)}>
                    <span className="material-icons-outlined">chevron_left</span>
                  </div>

                  <div className="d-flex gap-2 justify-content-center align-items-center">
                    {Array.from({ length: 7 }).map((_, idx) => {
                      const d = new Date(activeDate.getTime() + increaseNumber * 7 * 24 * 60 * 60 * 1000);
                      d.setDate(d.getDate() - d.getDay() + idx);
                      const dateStr = dateFormat(d);
                      const isSelected = selectedDates.some((selectedDate) => dateFormat(selectedDate) === dateStr);
                      return (
                        <div
                          key={idx}
                          onClick={() => {
                            setIncreaseNumber(0);
                            setSelectedDates((prev) => {
                              const alreadySelected = prev.find((item) => dateFormat(item) === dateStr);
                              if (alreadySelected) {
                                return prev.filter((item) => dateFormat(item) !== dateStr);
                              } else {
                                if (prev.length < 5) {
                                  return [...prev, d];
                                } else {
                                  toast.error('You can select up to 5 dates only');
                                  return prev;
                                }
                              }
                            });
                          }}
                          className={`text-center px-2 py-1 rounded border cursor-pointer small ${isSelected ? 'bg-primary text-white fw-bold' : 'bg-white text-dark'
                            }`}
                          style={{ minWidth: '40px' }}
                        >
                          <div className="text-capitalize">{weekDays[d.getDay()]}</div>
                          <div>{d.getDate()}</div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="slider-arrow px-2 cursor-pointer" onClick={() => setIncreaseNumber(increaseNumber + 1)}>
                    <span className="material-icons-outlined">chevron_right</span>
                  </div>
                </div>
              </>
            )}

            <div className="mb-2">
              <label className="mb-1 mt-3">Preferred Time</label>
              <div className="d-flex justify-content-between gap-10">
                <div className="w-100 d-flex flex-column">
                  <label style={{ fontSize: '10px' }} className="inputlabel ">
                    <span className="requiredInput"> * </span> Select Time
                  </label>
                  <DatePicker
                    format="hh:mm a"
                    showMeridian
                    hideMinutes={(m) => m % 15 !== 0}
                    onSelect={setPreferredFrom}
                  />
                </div>
              </div>
            </div>

            {selectedFrequency !== 'Custom' && (
              <div className="mb-2">
                <label className="inputlabel mb-1 mt-3">Session Start Date</label>
                <DatePicker
                  format="yyyy-MM-dd HH:mm"
                  placeholder="YYYY-MM-DD HH:MM"
                  value={sessionStartDate}
                  onChange={setSessionStartDate}
                  style={{ width: '100%' }}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <Button
          className="w-100 btn btn-primary"
          onClick={() => {
            if (!preferredFrom) {
              toast.error('Please select time');
              return;
            }

            if (selectedFrequency === 'Custom' && selectedDates.length === 0) {
              toast.error('Please select at least one date');
              return;
            }

            if (selectedFrequency !== 'Custom') {
              const gap = frequencyMap[selectedFrequency];
              if (gap) {
                const autoDates = [];
                for (let i = 0; i < 5; i++) {
                  const newDate = new Date(sessionStartDate);
                  newDate.setDate(sessionStartDate.getDate() + i * gap);
                  autoDates.push(newDate);
                }
                setSelectedDates(autoDates);
              }
            }

            setPreview(true);
            setAppointment(false);
          }}
        >
          Preview
        </Button>
      </Modal>

      <Modal open={showPreview} onClose={() => setPreview(false)}>
        <Modal.Header>
          <Modal.Title className="text-center w-full fw-bold fs-5">Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start mb-3">
            <Button
              variant="outline"
              style={{ backgroundColor: 'rgb(19, 56, 126)', color: 'white' }}
              onClick={() => {
                setPreview(false);
                setAppointment(true);
              }}
            >
              ← Back
            </Button>
          </div>

          <table className="table table-bordered w-100 text-center">
            <thead className="bg-light">
              <tr>
                <th>Session Number</th>
                <th>Date</th>
                <th>Allotted Slots</th>
              </tr>
            </thead>
            <tbody>
              {selectedDates.map((date, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{dateFormat(date)}✅</td>
                  <td>
                    {formatTime(preferredFrom)} - {formatTime(addMinutes(preferredFrom, sessionTime))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{ backgroundColor: 'rgb(19, 56, 126)' }}
            appearance="primary"
            className="w-100"
            onClick={() => {
              setPreview(false);
              resetAppointmentForm();
              toast.success('Appointment Created Successfully');
            }}
          >
            Create Appointment
          </Button>
        </Modal.Footer>
      </Modal>



      {/* <CommonAlert isShowAlert={isShowAlert} setIsShowAlert={setIsShowAlert} alertType={alertType} /> */}
      {
        isLoading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status" />
            <p className="mt-2">Loading services...</p>
          </div>
        ) : (
          <>
          <br/>
          {renderTabs()}
            <div className='d-flex header-right-part'>
              <div className='d-flex'>
                <div className='pt-3'>
                  
                  {(!userData?.read_only && (!["doctor","ee", "ee_manager"].includes(userData?.role) || userData?.department?.id == 2)) && (
                    <button className='reusableBtnActive reusableBtn' onClick={newQuestions}
                      style={{
                        fontSize: '16px',
                        padding: '10px 20px',
                        height: '30px',
                      }}
                    >
                      + Add New Service
                    </button>
                  )}
                </div>
              </div>
            </div>

            {renderNewServiceList()}

            <div className='d-flex justify-content-end'>
              {/* Pagination component can go here */}
            </div>
          </>
        )
      }


    </div>
  );
}

export default RenderService;